import { render, staticRenderFns } from "./PartnershipManagerEdit.vue?vue&type=template&id=47e5b595&"
import script from "./PartnershipManagerEdit.vue?vue&type=script&lang=js&"
export * from "./PartnershipManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports